import { useMemo } from "react";
import { useAppSelector } from "../redux-store/CustomReduxHooks";

const useCmsPageVariables = (cmsType: string) => {
  const cmsData = useAppSelector((st) => st.CmsSlice.CmsPageVariableData || []);

  const pageVariableData = useMemo(() => {
    if (!cmsData || cmsData.length === 0) return null;
    return cmsData.find((i) => i.attributes.cmsType === cmsType) ?? null;
  }, [cmsData, cmsType]);

  return pageVariableData;
};

export const useCmsPageErrorVariables = (cmsErrorCode: string) => {
  const cmsData = useAppSelector(
    (st) => st.CmsSlice.CmsErrorVariablesData || [],
  );

  const pageErrorVariableData = useMemo(() => {
    if (!cmsData || cmsData.length === 0) return null;
    return cmsData.find((i) => i.attributes.errorCode === cmsErrorCode) ?? null;
  }, [cmsData, cmsErrorCode]);

  return pageErrorVariableData;
};

export const useCmsNudgeText = (lob?: string) => {
  const cmsData = useAppSelector((st) => st.CmsSlice.CmsPageVariableData || []);

  const pageVariableData = useMemo(() => {
    if (!cmsData || cmsData.length === 0) return null;
    return (
      cmsData.find(
        (i) =>
          i.attributes.cmsType === "nudge" &&
          i.attributes.pageReference === window.location.pathname &&
          i.attributes.lobId === lob,
      ) ?? null
    );
  }, [cmsData, lob]);

  return pageVariableData;
};

export default useCmsPageVariables;
